export default __webpack_public_path__ + "static/media/sinPermiso.84cf93c6.png";